/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_ReadInputs */

const es_tools_outlook_read = /** @type {(inputs: Tools_Outlook_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo correo de Outlook...`)
};

const en_tools_outlook_read = /** @type {(inputs: Tools_Outlook_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Outlook message...`)
};

/**
* | output |
* | --- |
* | "Reading Outlook message..." |
*
* @param {Tools_Outlook_ReadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_read = /** @type {((inputs?: Tools_Outlook_ReadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_ReadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_read(inputs)
	return en_tools_outlook_read(inputs)
});
export { tools_outlook_read as "tools.outlook.read" }